<template>
  <el-dialog
    title="商品品种"
    :visible.sync="visible"
    width="500px"
    append-to-body
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      stripe
      :data="list">
      <el-table-column
        label="品种名称"
        :resizable="false"
        prop="className"></el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="95">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-button type="warning">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="editItem(row)">修改</el-dropdown-item>
              <el-dropdown-item @click.native="deleteItem(row)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="editprop(row)">属性编辑</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <cate-edit-modal
      ref="modal"
      :callback="fetchList" />
    <cate-prop-modal
      ref="prop"
      :callback="fetchList" />
    <div slot="footer">
      <el-button
        type="primary"
        @click="addItem">新增</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import CateEditModal from './cate-edit-modal.vue'
import CatePropModal from './cate-prop-modal.vue'
export default {
  name: 'CateModal',
  components: { CateEditModal, CatePropModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      category1: {},
      category2: {},
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 100
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {
        pageNum: 1,
        pageSize: 10
      }
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('industry/getcategorys', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          const category1 = res.data.categorys[0]
          const category2 = category1.children[0]
          const category3 = category2.children
          this.category1 = category1
          this.category2 = category2
          this.list = category3.map(i => {
            return {
              ...i,
              classId1: category1.classId,
              classId2: category2.classId
            }
          })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    },
    addItem() {
      this.$refs.modal.init({
        classId: null,
        className: '',
        parentClassId: this.category2.classId
      })
    },
    editItem(row) {
      this.$refs.modal.init({
        classId: row.classId,
        className: row.className,
        parentClassId: row.classId2
      })
    },
    editprop(row) {
      this.$refs.prop.fetch(row)
    },
    deleteItem(row) {
      this.$confirm('此操作将永久删除该品种, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('industry/deletecategory', {
            payload: {
              classId: row.classId
            },
            success: () => {
              this.loading = false
              // callback && callback()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
              // cancel && cancel()
            }
          })
        })
    }
  }
}
</script>
